import Icon from "@ant-design/icons";
import { ReactComponent as TiktokSvg } from "./svg/tiktok.svg";
import { ReactComponent as TiktokBoldSvg } from "./svg/tiktokBold.svg";

const TiktokIcon = (props) => <Icon component={TiktokSvg} {...props} />;
const TiktokBoldIcon = (props) => <Icon component={TiktokBoldSvg} {...props} />;

export default TiktokIcon;
export { TiktokBoldIcon };
